import * as commonActions from "../../common/actions";
import { errorMessage } from "../../../utils";
import {
  getSingleHeatPumpDeviceAPI,
  getHeatPumpDeviceHistoryBySerialNoAPI,
  getAllHeatPumpDevicesAPI,
  getMultiSiteCompaniesAPI,
  getCompaniesSitesAPI,
  getHeatPumpModelsAPI,
  updateHeatPumpDeviceAPI,
  getAllTagsAPI,
  assignTagsAPI,
  deleteTagAPI,
  updateTagAPI,
  getDeviceConnectionStatusAPI,
} from "./apis";
import { DownloadCSVAllDevicesAPI } from "../../common/apis";

export const GET_ALL_TAGS_REQUEST = "GET_ALL_TAGS_REQUEST";
export const GET_ALL_TAGS_SUCCESS = "GET_ALL_TAGS_SUCCESS";
export const GET_ALL_TAGS_FAILED = "GET_ALL_TAGS_FAILED";

export const getAllTags = (filters) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: GET_ALL_TAGS_REQUEST, });
    getAllTagsAPI(filters)
      .then((res) => {
        dispatch({
          type: GET_ALL_TAGS_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: GET_ALL_TAGS_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const ASSIGN_TAGS_REQUEST = "ASSIGN_TAGS_REQUEST";
export const ASSIGN_TAGS_SUCCESS = "ASSIGN_TAGS_SUCCESS";
export const ASSIGN_TAGS_FAILED = "ASSIGN_TAGS_FAILED";

export const assignTags = (filters) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ASSIGN_TAGS_REQUEST, });
    assignTagsAPI(filters)
      .then((res) => {
        dispatch({
          type: ASSIGN_TAGS_SUCCESS,
          payload: (res && res.info) || {},
        });

        dispatch(commonActions.openSnackbarsState({ message: res && res.message }));
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: ASSIGN_TAGS_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const DELETE_TAG_REQUEST = "DELETE_TAG_REQUEST";
export const DELETE_TAG_SUCCESS = "DELETE_TAG_SUCCESS";
export const DELETE_TAG_FAILED = "DELETE_TAG_FAILED";

export const deleteTag = (filters) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: DELETE_TAG_REQUEST, });
    deleteTagAPI(filters)
      .then((res) => {
        dispatch({
          type: DELETE_TAG_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: DELETE_TAG_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const UPDATE_TAG_REQUEST = "UPDATE_TAG_REQUEST";
export const UPDATE_TAG_SUCCESS = "UPDATE_TAG_SUCCESS";
export const UPDATE_TAG_FAILED = "UPDATE_TAG_FAILED";

export const updateTag = (filters) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: UPDATE_TAG_REQUEST, });
    updateTagAPI(filters)
      .then((res) => {
        dispatch({
          type: UPDATE_TAG_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_TAG_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const GET_ALL_MULTISITES_REQUEST = "GET_ALL_MULTISITES_REQUEST";
export const GET_ALL_MULTISITES_SUCCESS = "GET_ALL_MULTISITES_SUCCESS";
export const GET_ALL_MULTISITES_FAILED = "GET_ALL_MULTISITES_FAILED";

export const getAllMultiSiteCompanies = (filters) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_ALL_MULTISITES_REQUEST,
    });
    getMultiSiteCompaniesAPI(filters)
      .then((res) => {
        dispatch({
          type: GET_ALL_MULTISITES_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: GET_ALL_MULTISITES_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const GET_SITES_REQUEST = "GET_SITES_REQUEST";
export const GET_SITES_SUCCESS = "GET_SITES_SUCCESS";
export const GET_SITES_FAILED = "GET_SITES_FAILED";

export const getCompaniesSites = (filters, mscId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_SITES_REQUEST,
    });
    getCompaniesSitesAPI(filters, mscId)
      .then((res) => {
        dispatch({
          type: GET_SITES_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: GET_SITES_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const GET_HEAT_PUMP_DEVICES_REQUEST = "GET_HEAT_PUMP_DEVICES_REQUEST";
export const GET_HEAT_PUMP_DEVICES_SUCCESS = "GET_HEAT_PUMP_DEVICES_SUCCESS";
export const GET_HEAT_PUMP_DEVICES_FAILED = "GET_HEAT_PUMP_DEVICES_FAILED";

export const getallHeatPumpDevices = (filters) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_HEAT_PUMP_DEVICES_REQUEST,
    });
    getAllHeatPumpDevicesAPI(filters)
      .then((res) => {
        dispatch({
          type: GET_HEAT_PUMP_DEVICES_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: GET_HEAT_PUMP_DEVICES_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const GET_SINGLE_HEAT_PUMP_REQUEST = "GET_SINGLE_HEAT_PUMP_REQUEST";
export const GET_SINGLE_HEAT_PUMP_SUCCESS = "GET_SINGLE_HEAT_PUMP_SUCCESS";
export const GET_SINGLE_HEAT_PUMP_FAILED = "GET_SINGLE_HEAT_PUMP_FAILED";

export const getSingleHeatPumpDevice = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_SINGLE_HEAT_PUMP_REQUEST,
    });
    getSingleHeatPumpDeviceAPI(id)
      .then((res) => {
        dispatch({
          type: GET_SINGLE_HEAT_PUMP_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({
          type: GET_SINGLE_HEAT_PUMP_FAILED,
        });
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });

export const GET_HEAT_PUMP_DEVICE_HISTORY_REQUEST = "GET_HEAT_PUMP_DEVICE_HISTORY_REQUEST";
export const GET_HEAT_PUMP_DEVICE_HISTORY_SUCCESS = "GET_HEAT_PUMP_DEVICE_HISTORY_SUCCESS";
export const GET_HEAT_PUMP_DEVICE_HISTORY_FAILED = "GET_HEAT_PUMP_DEVICE_HISTORY_FAILED";

export const getHeatPumpDeviceHistoryBySerialNo =
  (mac_address, type, name, id, date = {}) =>
    (dispatch) =>
      new Promise((resolve, reject) => {
        dispatch({
          type: GET_HEAT_PUMP_DEVICE_HISTORY_REQUEST,
        });
        getHeatPumpDeviceHistoryBySerialNoAPI(mac_address, type, name, id, date)
          .then((res) => {
            const { info = [] } = res || {};
            dispatch({
              type: GET_HEAT_PUMP_DEVICE_HISTORY_SUCCESS,
              payload: info,
            });
            // dispatch(commonActions.openSnackbarsState({ message: res && res.message }))
            return resolve(res);
          })
          .catch((err) => {
            dispatch({
              type: GET_HEAT_PUMP_DEVICE_HISTORY_FAILED,
            });
            dispatch(
              commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
            );
            return reject(err);
          });
      });

export const DownloadCSVAllDevices = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    DownloadCSVAllDevicesAPI()
      .then((res) => {
        return resolve(res);
      })
      .catch((err) => {
        dispatch(
          commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" })
        );
        return reject(err);
      });
  });
};

export const GET_HEAT_PUMP_MODELS_REQUEST = "GET_HEAT_PUMP_MODELS_REQUEST";
export const GET_HEAT_PUMP_MODELS_SUCCESS = "GET_HEAT_PUMP_MODELS_SUCCESS";
export const GET_HEAT_PUMP_MODELS_FAILED = "GET_HEAT_PUMP_MODELS_FAILED";

export const getHeatPumpModels = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: GET_HEAT_PUMP_MODELS_REQUEST });
    getHeatPumpModelsAPI(id)
      .then((res) => {
        dispatch({
          type: GET_HEAT_PUMP_MODELS_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({ type: GET_HEAT_PUMP_MODELS_FAILED });
        dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" }));
        return reject(err);
      });
  });

export const UPDATE_HEAT_PUMP_MODELS_REQUEST = "UPDATE_HEAT_PUMP_MODELS_REQUEST";
export const UPDATE_HEAT_PUMP_MODELS_SUCCESS = "UPDATE_HEAT_PUMP_MODELS_SUCCESS";
export const UPDATE_HEAT_PUMP_MODELS_FAILED = "UPDATE_HEAT_PUMP_MODELS_FAILED";

export const updateHeatPumpDevice = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: UPDATE_HEAT_PUMP_MODELS_REQUEST });
    updateHeatPumpDeviceAPI(id)
      .then((res) => {
        dispatch({
          type: UPDATE_HEAT_PUMP_MODELS_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({ type: UPDATE_HEAT_PUMP_MODELS_FAILED });
        dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" }));
        return reject(err);
      });
  });


export const GET_DEVICE_CONNECTION_STATUS_REQUEST = "GET_DEVICE_CONNECTION_STATUS_REQUEST";
export const GET_DEVICE_CONNECTION_STATUS_SUCCESS = "GET_DEVICE_CONNECTION_STATUS_SUCCESS";
export const GET_DEVICE_CONNECTION_STATUS_FAILED = "GET_DEVICE_CONNECTION_STATUS_FAILED";

export const getDeviceConnectionStatus = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: GET_DEVICE_CONNECTION_STATUS_REQUEST });
    getDeviceConnectionStatusAPI(id)
      .then((res) => {
        dispatch({
          type: GET_DEVICE_CONNECTION_STATUS_SUCCESS,
          payload: (res && res.info) || {},
        });
        return resolve(res);
      })
      .catch((err) => {
        dispatch({ type: GET_DEVICE_CONNECTION_STATUS_FAILED });
        dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: "error" }));
        return reject(err);
      });
  });